const endpoints = {
	forgeGetToken: '/forge/forgeGetToken',
	forgeGetFiles: '/forge/getForgeFiles',
	getSupportedExtensions: '/forge/getSupportedExtensions',
	setProjectMainModel: '/forge/setProjectMainModel',
	addFileToForge: '/forge/addFileToForge',
	getProjectMainModel: '/forge/getProjectMainModel',
	deleteProjectMainModel: '/forge/deleteProjectMainModel',
	removeFromForge: '/forge/removeFromForge'
}
export {endpoints}